module.exports = __webpack_public_path__ + "static/img/inis2-2.a0611a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inis2-2.png
// module id = 8uNV
// module chunks = 1